import * as React from "react";
import {PaymentRequest} from "../../models/PaymentRequest";
import update = require("react-addons-update");
import {CreditCardNumber} from "./CreditCardNumber";
import {TextBox} from "./TextBox";

export interface CreditCardPaymentProps
{
	fieldName: string;
	accountNumberlabel?: string;
	accountNameLabel?: string;
	accountNamePlaceholder?: string;
	expiresLabel?: string;
	expiresPlaceholder?: string;
	securityCodeLabel?: string;
	securityCodePlaceholder?: string;
	paymentRequestUpdated?: (request: PaymentRequest) => void;
	selectedPaymentMethod?: string;
	shouldTriggerVaidation?: boolean;
}

export interface CreditCardPaymentState
{
	accountName: string;
	accountNumber: string;
	expires: string;
	securityCode: string;
}

enum CreditCardType
{
	Unknown,
	AmericanExpress,
	Discover,
	MasterCard,
	Visa
}

export class CreditCardPayment extends React.Component<CreditCardPaymentProps, CreditCardPaymentState>
{
	static defaultProps: CreditCardPaymentProps =
	{
		fieldName: "ChangeCreditCardPaymentFieldName",
		accountNumberlabel: "Account Number",
		accountNameLabel: "Name on Account",
		accountNamePlaceholder: "John Doe",
		expiresLabel: "Expires",
		expiresPlaceholder: "MM/YYYY",
		securityCodeLabel: "Security Code",
		securityCodePlaceholder: "000",
		selectedPaymentMethod: "",
		shouldTriggerVaidation: false
	};

	componentWillMount()
	{
		this.setState({ accountName: "", accountNumber: "", expires: "", securityCode: "" });
	}

	private isAmex(accountNumber: string)
	{
		if (accountNumber && accountNumber.length >= 2)
		{
			if (accountNumber[0] === "3" && accountNumber[1] === "7")
			{
				return true;
			}
		}
		return false;
	}

	private isVisa(accountNumber: string)
	{
		if (accountNumber && accountNumber.length >= 1)
		{
			if (accountNumber[0] === "4")
			{
				return true;
			}
		}
		return false;
	}

	private isMastercard(accountNumber: string)
	{
		if (accountNumber && accountNumber.length >= 1)
		{
			if (accountNumber[0] === "5")
			{
				return true;
			}
		}
		return false;
	}

	private isDiscover(accountNumber: string)
	{
		if (accountNumber && accountNumber.length >= 1)
		{
			if (accountNumber[0] === "6")
			{
				return true;
			}
		}
		return false;
	}

	private cardType(accountNumber: string): CreditCardType
	{
		if (this.isAmex(accountNumber))
		{
			return CreditCardType.AmericanExpress;
		}
		if (this.isVisa(accountNumber))
		{
			return CreditCardType.Visa;
		}
		if (this.isMastercard(accountNumber))
		{
			return CreditCardType.MasterCard;
		}
		if (this.isDiscover(accountNumber))
		{
			return CreditCardType.Discover;
		}

		return CreditCardType.Unknown;
	}

	render()
	{
		var ccNumberMask = this.getCCNumberMask();
		var ccvMask = this.getCCVMask();
		var ccvPlaceHolder = this.getCCVPlaceholder();
		var ccNumberPlaceHolder = this.getCCNumberPlacholder();
		return <div>
			       <TextBox
				       onChange={this.updateAccountName.bind(this) }
				       label={this.props.accountNameLabel}
				       placeholder={this.props.accountNamePlaceholder}
				       fieldName={this.props.fieldName + "-name"}
				       isRequired={this.props.shouldTriggerVaidation}
				       requiredMessage={"This field is required"}/>
			       <CreditCardNumber
				       updatedValueCallBack={this.updateCreditCard.bind(this) }
				       label={this.props.accountNumberlabel}
				       fieldName={this.props.fieldName + "-number"}
				       shouldTriggerValidation={this.props.shouldTriggerVaidation}
				       placeholder={ccNumberPlaceHolder}
				       mask={ccNumberMask}/>
			       <div className="row">
				       <div className="col-md-6">
					       <TextBox
						       onChange={this.updateAccountExpiration.bind(this) }
						       label={this.props.expiresLabel}
						       placeholder={this.props.expiresPlaceholder}
						       fieldName={this.props.fieldName + "-expires"}
						       mask="11/1111"
						       isRequired={this.props.shouldTriggerVaidation}
						       requiredMessage={"This field is required"}/>
				       </div>
				       <div className="col-md-6">
					       <TextBox
						       onChange={this.updateAccountSecurityCode.bind(this) }
						       label={this.props.securityCodeLabel}
						       placeholder={ccvPlaceHolder}
						       fieldName={this.props.fieldName + "-security"}
						       mask={ccvMask}
						       isRequired={this.props.shouldTriggerVaidation}
						       requiredMessage={"This field is required"}/>
				       </div>
			       </div>
		       </div>;
	}

	private getCCNumberMask()
	{
		var paymentMethod = this.props.selectedPaymentMethod;
		if (paymentMethod === "5186D8D968585543388B88D2") //american express
		{
			return "1111 111111 11111";
		} else
		{
			return "1111 1111 1111 1111";
		}
	}

	private getCCVMask()
	{
		var paymentMethod = this.props.selectedPaymentMethod;
		if (paymentMethod === "5186D8D968585543388B88D2") //american express
		{
			return "1111";
		} else
		{
			return "111";
		}
	}

	private getCCVPlaceholder()
	{
		var paymentMethod = this.props.selectedPaymentMethod;
		if (paymentMethod === "5186D8D968585543388B88D2") //american express
		{
			return "0000";
		} else
		{
			return this.props.securityCodePlaceholder;
		}
	}

	private getCCNumberPlacholder()
	{
		var paymentMethod = this.props.selectedPaymentMethod;
		if (paymentMethod === "5186D8D968585543388B88D2") //american express
		{
			return "____ ______ _____";
		} else
		{
			return "____ ____ ____ ____";
		}
	}

	updateAccountName(ev: any)
	{
		const state = update(this.state, { $set: { accountName: ev.target.value } });
		this.setState(state);
		this.buildPaymentRequest();
	}

	updateCreditCard(ev: any)
	{
		const state = update(this.state, { $set: { accountNumber: ev.target.value } });
		this.setState(state);
		this.buildPaymentRequest();
	}

	updateAccountExpiration(ev: any)
	{
		const state = update(this.state, { $set: { expires: ev.target.value } });
		this.setState(state);
		this.buildPaymentRequest();
	}

	updateAccountSecurityCode(ev: any)
	{
		const state = update(this.state, { $set: { securityCode: ev.target.value } });
		this.setState(state);
		this.buildPaymentRequest();
	}

	private buildPaymentRequest()
	{
		setTimeout(() =>
			{
				if (this.props.paymentRequestUpdated)
				{
					var paymentRequest = new PaymentRequest();
					paymentRequest.paymentType = 0; //creditcard
					paymentRequest.name = this.state.accountName;
					paymentRequest.accountNumber = this.state.accountNumber;
					paymentRequest.verification = this.state.securityCode;
					var expires = this.state.expires.split("/");
					if (expires.length === 2)
					{
						paymentRequest.expirationMonth = expires[0];
						paymentRequest.expirationYear = expires[1];
					}
					this.props.paymentRequestUpdated(paymentRequest);
				}
			},
			0);
	}
}


// WEBPACK FOOTER //
// ./src/components/common/CreditCardPayment.tsx